import { render, staticRenderFns } from "./CodingDashboardLanding.vue?vue&type=template&id=2c16c08a&scoped=true&"
import script from "./CodingDashboardLanding.vue?vue&type=script&lang=js&"
export * from "./CodingDashboardLanding.vue?vue&type=script&lang=js&"
import style0 from "./CodingDashboardLanding.vue?vue&type=style&index=0&id=2c16c08a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c16c08a",
  null
  
)

export default component.exports